import { render } from "./PersonalizacionTipster.vue?vue&type=template&id=3935fe12&scoped=true"
import script from "./PersonalizacionTipster.vue?vue&type=script&lang=js"
export * from "./PersonalizacionTipster.vue?vue&type=script&lang=js"

import "./PersonalizacionTipster.vue?vue&type=style&index=0&id=3935fe12&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3935fe12"]])

export default __exports__